import { render, staticRenderFns } from "./VFairHack.vue?vue&type=template&id=5ee948d1&"
import script from "./VFairHack.vue?vue&type=script&lang=js&"
export * from "./VFairHack.vue?vue&type=script&lang=js&"
import style0 from "./VFairHack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports